module.exports = __webpack_public_path__ + "static/media/Shantal Alonso Headshot.de8fefab.jpeg";